// Obtidos no painel da GATE2all (https://portal.gate2all.com.br) Config. Autorização
export const PAYGO_API_KEY = "92D76B204AA0496B8E14";
export const PAYGO_API_SECRET = "D4E80D5BFF044747BA19";

export const AUTH_API = "vallparking";
export const AUTH_KEY = "009D34DD613572536C1C";